/*
 * @Description: singUp model
 * @Author: 山淑兰
 * @Date: 2019-12-26 21:36:03
 * @LastEditTime : 2020-01-07 18:17:06
 * @LastEditors  : 山淑兰
 */
export const Flags = {
  active: 0,
  showLoading: false,
  moduleLoading: false,
};
